var _classCallCheck = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/ksegweb/kseg-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

/*! For license information please see index.js.LICENSE.txt */

/*!
 * banner:
 * react-customscroll: 4.5.1
 * Aleksandrov Sergey <gooddev.sergey@gmail.com> (https://github.com/AlexSergey/react-customscroll)
 * This is little custom scroll React component.
 * MIT
 */
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.CustomScroll = e(require("react")) : t.CustomScroll = e(t.react);
}(this, function (t) {
  return function (t) {
    var e = {};

    function s(o) {
      if (e[o]) return e[o].exports;
      var r = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, s), r.l = !0, r.exports;
    }

    return s.m = t, s.c = e, s.d = function (t, e, o) {
      s.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, s.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, s.t = function (t, e) {
      if (1 & e && (t = s(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (s.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) {
        s.d(o, r, function (e) {
          return t[e];
        }.bind(null, r));
      }
      return o;
    }, s.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return s.d(e, "a", e), e;
    }, s.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, s.p = "/", s(s.s = 9);
  }([function (t, e, s) {
    "use strict";

    s.d(e, "d", function () {
      return i;
    }), s.d(e, "c", function () {
      return o;
    }), s.d(e, "b", function () {
      return r;
    }), s.d(e, "a", function () {
      return l;
    });

    var o = function o(t) {
      return "function" == typeof t;
    },
        r = function r(t) {
      return void 0 !== t;
    },
        l = function l() {
      return "undefined" != typeof window;
    },
        i = function i(t) {
      return "object" == typeof t;
    };
  }, function (e, s) {
    e.exports = t;
  }, function (t, e, s) {
    "use strict";

    function o(t, e, s) {
      e.forEach(function (e) {
        t.addEventListener(e, s);
      });
    }

    function r(t, e, s) {
      e.forEach(function (e) {
        t.removeEventListener(e, s);
      });
    }

    s.d(e, "b", function () {
      return o;
    }), s.d(e, "a", function () {
      return r;
    });
  }, function (t, e, s) {
    "use strict";

    function o(t, e, s) {
      if (s <= 0) return !1;
      var r = (e - t.scrollTop) / s * 10;
      setTimeout(function () {
        t.scrollTop = t.scrollTop + r, t.scrollTop !== e && o.call(this, t, e, s - 10);
      }.bind(this), 10);
    }

    e.a = function (t, e, s) {
      s ? o.call(this, t, e, 500) : t.scrollTop = e;
    };
  }, function (t, e, s) {
    "use strict";

    function o() {
      return "_" + Math.random().toString(36).substr(2, 9);
    }

    s.d(e, "a", function () {
      return o;
    });
  }, function (t, e, s) {
    "use strict";

    s.d(e, "a", function () {
      return r;
    });
    var o = s(0);

    function r() {
      if (!Object(o.a)()) return 0;
      var t = document.createElement("p");
      t.style.width = "100%", t.style.height = "200px";
      var e = document.createElement("div");
      e.style.position = "absolute", e.style.top = "0px", e.style.left = "0px", e.style.visibility = "hidden", e.style.width = "200px", e.style.height = "150px", e.style.overflow = "hidden", e.appendChild(t), document.body.appendChild(e);
      var s = t.offsetWidth;
      e.style.overflow = "scroll";
      var r = t.offsetWidth;
      return s === r && (r = e.clientWidth), document.body.removeChild(e), s - r;
    }
  }, function (t, e, s) {
    "use strict";

    function o(t, e) {
      var s = document.head || document.getElementsByTagName("head")[0],
          o = document.createElement("style");
      o.setAttribute("id", e), o.type = "text/css", o.styleSheet ? o.styleSheet.cssText = t : o.appendChild(document.createTextNode(t)), s.appendChild(o);
    }

    s.d(e, "a", function () {
      return o;
    });
  }, function (t, e, s) {
    "use strict";

    e.a = function (t, e) {
      return {
        scrollArea: Object.assign({
          background: t.scrollAreaColor,
          width: t.scrollWidth,
          padding: "1px",
          zIndex: "10",
          position: "absolute",
          height: "100%"
        }, e ? {
          top: "0",
          left: "0"
        } : {
          top: "0",
          right: "0"
        }),
        scrollAreaFrame: {
          height: "100%",
          position: "relative"
        },
        scrollBar: Object.assign({
          borderRadius: t.scrollBarRadius,
          position: "absolute",
          top: "0",
          width: "100%",
          background: t.scrollBarColor,
          cursor: "pointer"
        }),
        ctmScroll: {
          overflow: "hidden",
          height: "100%",
          position: "relative"
        },
        ctmScrollActive: Object.assign({}, e ? {
          paddingLeft: t.scrollWidth
        } : {
          paddingRight: t.scrollWidth
        }),
        ctmScrollFrame: Object.assign({}, t.virtualized ? {
          height: "100%",
          width: "100%"
        } : {
          overflow: "hidden"
        }, t.isZero ? {
          width: "calc(100% - ".concat(t.originalScrollWidth, "px)")
        } : {}),
        noselect: {
          WebkitTouchCallout: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none"
        },
        ctmScrollHolder: {
          overflowY: "scroll",
          height: "100%"
        }
      };
    };
  }, function (t, e, s) {
    "use strict";

    function o() {
      document.selection ? document.selection.empty() : window.getSelection && window.getSelection().removeAllRanges();
    }

    s.d(e, "a", function () {
      return o;
    });
  }, function (t, e, s) {
    "use strict";

    s.r(e), function (t) {
      var o = s(1),
          r = s.n(o),
          l = s(2),
          i = s(5),
          c = s(8),
          n = s(7),
          a = s(3),
          h = s(6),
          u = s(4),
          d = s(0);

      var p =
      /*#__PURE__*/
      function (_o$Component) {
        _inherits(p, _o$Component);

        function p(t) {
          var _this;

          _classCallCheck(this, p);

          _this = _possibleConstructorReturn(this, _getPrototypeOf(p).call(this, t)), ["scroll-area", "scroll-area-holder", "scrollBar", "customScroll", "customScrollHolder", "customScrollFrame"].forEach(function (t) {
            _this[t + "Ref"] = Object(o.createRef)();
          }), _this.nextWrapperHeight = 0, _this.nextHolderHeight = 0, _this.scrollID = Object(u.a)(), p.scrollWidth || (p.scrollWidth = Object(i.a)());

          var e = p.scrollWidth,
              s = _assertThisInitialized(_assertThisInitialized(_this));

          _this.isZero = 0 === e, _this.isVirtualized = Object(d.d)(t.virtualized), _this.isZero && (e = 17), _this.reset = function () {
            s.removeListeners(), s.blockSelection(!0);
          };
          var r = Object(d.b)(t.className) ? t.className : "react-customscroll";
          _this.restScrollAfterResize = function () {
            s.nextWrapperHeight = 0, s.nextHolderHeight = 0;
          }, _this.timer = {}, _this.interval = setInterval(_this.reinit.bind(_assertThisInitialized(_assertThisInitialized(_this))), 250), _this.state = {
            width: "calc(100% + ".concat(e, "px)"),
            selection: !0,
            scrollAreaShow: !1,
            animate: t.animate || !0,
            classes: {
              base: r,
              holder: r + "-holder",
              frame: r + "-frame",
              area: r + "-scrollbar-area",
              "area-holder": r + "-scrollbar-holder",
              "scroll-bar": r + "-scrollbar"
            },
            virtualState: _this.isVirtualized ? _this.getScrollBarStyles(t.scrollTo || 0) : null,
            styles: {}
          }, Object(d.a)() && (document.getElementById(_this.scrollID) || Object(h.a)("#".concat(_this.scrollID, "::-webkit-scrollbar { opacity: 0 }\n#").concat(_this.scrollID, "::-webkit-scrollbar-track-piece { background-color: transparent }"), _this.scrollID));
          return _this;
        }

        _createClass(p, [{
          key: "applyStyles",
          value: function applyStyles() {
            var e = p.scrollWidth,
                s = !1;

            if (Object(d.a)()) {
              s = "rtl" === t.getComputedStyle(this.customScrollHolder).direction;
            }

            this.setState(Object.assign(this.state, {
              styles: Object(n.a)({
                virtualized: this.isVirtualized,
                isZero: this.isZero,
                originalScrollWidth: e,
                scrollWidth: Object(d.b)(this.props.scrollWidth) ? this.props.scrollWidth : "6px",
                scrollAreaColor: Object(d.b)(this.props.scrollAreaColor) ? this.props.scrollAreaColor : "#494949",
                scrollBarRadius: Object(d.b)(this.props.scrollBarRadius) ? this.props.scrollBarRadius : "6px",
                scrollBarColor: Object(d.b)(this.props.scrollBarColor) ? this.props.scrollBarColor : "#aeaeae"
              }, s)
            }));
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            Object(l.b)(document, ["mouseWithoutWindow"], this.reset), Object(l.b)(window, ["resize"], this.restScrollAfterResize), this.scrollBlock = this.customScrollHolderRef.current, this.customScroll = this.customScrollRef.current, this.customScrollHolder = this.customScrollFrameRef.current, this.applyStyles();
          }
        }, {
          key: "componentWillUnmount",
          value: function componentWillUnmount() {
            if (Object(d.a)()) {
              var _t = document.getElementById(this.scrollID);

              _t && _t.parentNode.removeChild(_t);
            }

            clearInterval(this.interval), this.removeListeners(), clearTimeout(this.timer);
          }
        }, {
          key: "getParams",
          value: function getParams() {
            var t = 0,
                e = 0,
                s = 0,
                o = 0;
            if (!Object(d.a)()) return {
              wrapperHeight: t,
              holderHeight: e,
              percentDiff: s,
              height: o
            };
            var r = this["scroll-areaRef"].current,
                l = window && r ? parseFloat(window.getComputedStyle(r, null).getPropertyValue("padding-top")) + parseFloat(window.getComputedStyle(r, null).getPropertyValue("padding-bottom")) : 0;
            return this.isVirtualized ? (t = this.props.virtualized.height || 0, e = this.props.virtualized.scrollHeight || 0) : (t = this.customScroll && this.customScroll.offsetHeight, e = this.customScroll && this.customScrollHolder.offsetHeight), 0 === e ? (o = 0, s = 0) : (s = (t - l) / e, o = t * s), {
              wrapperHeight: Math.ceil(t),
              holderHeight: e,
              percentDiff: s,
              height: o
            };
          }
        }, {
          key: "blockSelection",
          value: function blockSelection(t) {
            t || Object(c.a)(), this.setState({
              selection: !!t
            });
          }
        }, {
          key: "onMouseDown",
          value: function onMouseDown(t) {
            var e;
            if (t.stopPropagation(), t.preventDefault(), "which" in t ? e = 3 === t.which : "button" in t && (e = 2 === t.button), e) return setTimeout(this.endScroll), !1;
            var s = this.scrollBlock,
                o = t.touches ? t.touches[0].pageY : t.pageY,
                r = this.isVirtualized ? this.props.scrollTo || 0 : s.scrollTop;
            this.blockSelection(!1);
            var i = this;
            this.scrollRun = function (t) {
              t.stopPropagation(), t.preventDefault();

              var _i$getParams = i.getParams(),
                  e = _i$getParams.holderHeight,
                  l = _i$getParams.wrapperHeight,
                  c = e / l,
                  n = t.touches ? t.touches[0].pageY : t.pageY;

              if (i.isVirtualized) {
                var _t2 = (n - o) * c + r;

                _t2 = e - l <= _t2 ? e - l : _t2, Object(d.c)(i.props.scrollSync) && i.props.scrollSync(_t2);
              } else Object(a.a)(s, (n - o) * c + r);
            }, this.endScroll = function () {
              i.removeListeners(), i.blockSelection(!0);
            }, Object(l.b)(document, ["mouseup", "touchend"], this.endScroll), Object(l.b)(document, ["mousemove", "touchmove"], this.scrollRun);
          }
        }, {
          key: "removeListeners",
          value: function removeListeners() {
            Object(l.a)(document, ["mouseWithoutWindow"], this.reset), Object(l.a)(window, ["resize"], this.restScrollAfterResize), Object(l.a)(document, ["mouseup", "touchend"], this.endScroll), Object(l.a)(document, ["mousemove", "touchmove"], this.scrollRun);
          }
        }, {
          key: "reinit",
          value: function reinit() {
            var _this$getParams = this.getParams(),
                t = _this$getParams.wrapperHeight,
                e = _this$getParams.holderHeight;

            if (t !== this.nextWrapperHeight || e !== this.nextHolderHeight) if (this.isVirtualized) {
              var _s = this.props.scrollTo || 0,
                  _o = this.getScrollBarStyles(_s);

              this.setState({
                virtualState: _o,
                scrollAreaShow: e > t
              });
            } else this.setState({
              scrollAreaShow: e > t
            });
            this.nextWrapperHeight = t, this.nextHolderHeight = e;
          }
        }, {
          key: "jump",
          value: function jump(t) {
            var e = t.touches ? t.touches[0].pageY : t.pageY,
                s = this.scrollBarRef.current,
                o = this.scrollBlock.scrollTop,
                _this$getParams2 = this.getParams(),
                r = _this$getParams2.wrapperHeight,
                l = this.scrollBlock.getBoundingClientRect().top;

            if (this.isVirtualized && (s = {}, o = this.props.scrollTo || 0, s.offsetTop = this.state.virtualState.top, s.offsetHeight = this.state.virtualState.height), e < l + s.offsetTop || e > l + s.offsetTop + s.offsetHeight) {
              var _t3 = o + r * (l + s.offsetTop <= e ? 1 : -1);

              this.isVirtualized ? Object(d.c)(this.props.scrollSync) && this.props.scrollSync(_t3) : Object(a.a)(this.scrollBlock, _t3);
            }
          }
        }, {
          key: "getScrollArea",
          value: function getScrollArea() {
            return r.a.createElement("div", {
              ref: this["scroll-areaRef"],
              style: this.state.styles.scrollArea,
              onClick: this.jump.bind(this),
              className: this.state.classes.area
            }, r.a.createElement("div", {
              ref: this["scroll-area-holderRef"],
              style: this.state.styles.scrollAreaFrame,
              className: this.state.classes["area-holder"]
            }, r.a.createElement("div", {
              ref: this.scrollBarRef,
              style: Object.assign({}, this.state.styles.scrollBar, this.isVirtualized ? this.state.virtualState : this.getScrollBarStyles.call(this)),
              onMouseDown: this.onMouseDown.bind(this),
              onTouchStart: this.onMouseDown.bind(this),
              className: this.state.classes["scroll-bar"]
            })));
          }
        }, {
          key: "scroll",
          value: function scroll() {
            this.setState({
              scrollTop: this.scrollBlock.scrollTop
            });
          }
        }, {
          key: "getScrollBarStyles",
          value: function getScrollBarStyles(t) {
            var _this$getParams3 = this.getParams(),
                e = _this$getParams3.holderHeight,
                s = _this$getParams3.percentDiff,
                o = _this$getParams3.height;

            return 0 === e && 0 === s && 0 === o ? {
              top: 0,
              height: 0
            } : {
              top: (this.isVirtualized ? t : this.state.scrollTop || this.scrollBlock.scrollTop) * (o < 20 ? s - (20 - o) / e : s),
              height: o < 20 ? 20 : o
            };
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(t) {
            var e = parseInt(this.props.scrollTo, 10);
            Object(d.b)(e) && !isNaN(e) && t.scrollTo !== e && (this.isVirtualized ? (e = e || 0, this.setState({
              virtualState: this.getScrollBarStyles(e)
            })) : a.a.call(this, this.scrollBlock, e, this.state.animate));
          }
        }, {
          key: "setY",
          value: function setY(t) {
            a.a.call(this, this.scrollBlock, t, this.state.animate);
          }
        }, {
          key: "render",
          value: function render() {
            var t = this.state.selection ? this.state.styles.ctmScroll : Object.assign({}, this.state.styles.ctmScroll, this.state.styles.noselect),
                e = this.state.scrollAreaShow ? Object.assign({}, this.state.styles.ctmScrollFrame, this.state.styles.ctmScrollActive) : this.state.styles.ctmScrollFrame;
            return r.a.createElement("div", {
              ref: this.customScrollRef,
              style: Object.assign({
                boxSizing: "border-box"
              }, t),
              className: this.state.classes.base,
              suppressHydrationWarning: !0
            }, r.a.createElement("div", {
              ref: this.customScrollHolderRef,
              style: Object.assign({
                boxSizing: "border-box"
              }, {
                width: this.state.width
              }, this.state.styles.ctmScrollHolder),
              onScroll: this.scroll.bind(this),
              className: this.state.classes.holder,
              id: this.scrollID,
              suppressHydrationWarning: !0
            }, r.a.createElement("div", {
              ref: this.customScrollFrameRef,
              style: Object.assign({
                boxSizing: "border-box"
              }, e, this.isZero ? {
                width: "100%"
              } : {}),
              className: this.state.classes.frame,
              suppressHydrationWarning: !0
            }, Object(d.c)(this.props.children) ? this.props.children(this.scrollBlock && this.scrollBlock.scrollTop ? this.scrollBlock.scrollTop : 0) : this.props.children), this.state.scrollAreaShow ? this.getScrollArea.call(this) : null));
          }
        }]);

        return p;
      }(o.Component);

      e.default = p;
    }.call(this, s(10));
  }, function (t, e) {
    var s;

    s = function () {
      return this;
    }();

    try {
      s = s || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (s = window);
    }

    t.exports = s;
  }]);
});